import { areaStore } from '~/stores/area';

export const baselineServices = () => {
  const getAreaWithAnEnergyUseType = () => {
    const { getAreas } = areaStore();
    return getAreas.filter((area) => area.energy_use_type);
  };

  return {
    getAreaWithAnEnergyUseType,
  };
};
